/* Kingswood: the header cart opens on hover, like the shopping bag on montblanc.com. The drawer slides
   in below the header and stays until it is closed (its X, Escape, or a click outside it). Pointer
   devices at desktop width only; a click still opens it the Dawn way (focus moves inside), so keyboards
   and touch are unchanged. While the drawer is open the cart icon keeps its round backing (kw-luxe.css,
   .is-open).
   Loaded from layout/theme.liquid next to cart-drawer.js when the cart type is "drawer". */
(() => {
  const icon = document.getElementById('cart-icon-bubble');
  const drawer = document.querySelector('cart-drawer');
  if (!icon || !drawer) return;
  const hoverable = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  const header = document.querySelector('.section-header');
  let timer;
  let top = -1;
  let following = false;

  /* The drawer hangs below the header (kw-luxe.css reads --kw-drawer-top at desktop width). The sticky
     header slides in and out as the page scrolls, so its bottom edge is followed frame by frame, but
     only while the drawer is open. */
  const place = () => {
    const edge = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    if (edge === top) return;
    top = edge;
    document.documentElement.style.setProperty('--kw-drawer-top', edge + 'px');
  };
  const follow = () => {
    if (!drawer.classList.contains('active')) {
      following = false;
      return;
    }
    place();
    requestAnimationFrame(follow);
  };

  icon.addEventListener('mouseenter', () => {
    if (!hoverable.matches || drawer.classList.contains('active')) return;
    /* A short delay so a pointer passing over the icon does not open it. Adding the classes is what
       CartDrawer.open() does, minus the page-scroll lock and the focus trap - a hover must not take
       focus or freeze the page; the drawer's own close paths (overlay, X, Escape) work as usual. */
    timer = setTimeout(() => {
      place();
      drawer.classList.add('animate', 'active');
    }, 150);
  });
  icon.addEventListener('mouseleave', () => clearTimeout(timer));

  /* The icon is no longer covered by the open drawer. A click on it then (the habit after a hover) only
     moves focus into the drawer: Dawn's open() must not run a second time, nor the link go to /cart. */
  document.addEventListener(
    'click',
    (event) => {
      if (!drawer.classList.contains('active') || !icon.contains(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.focus({ preventScroll: true });
    },
    true
  );

  /* Every way of opening (hover, click, add to cart) ends in the class change: place the drawer before
     it is painted, then follow the header. */
  new MutationObserver(() => {
    const open = drawer.classList.contains('active');
    icon.classList.toggle('is-open', open);
    if (!open || following) return;
    following = true;
    place();
    requestAnimationFrame(follow);
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
})();
